import React, { Component } from 'react';
import {LinkContainer} from "react-router-bootstrap";
import {Button} from "react-bootstrap";

export default class Loading extends Component {

    render() {
        return (
            <div>
                <span>You need to be a premium member to {this.props.to}. Please consider upgrading to the premium tier.</span> <br /><br />

                <LinkContainer to="/upgrade">
                    <Button bsStyle="primary">Upgrade to premium</Button>
                </LinkContainer>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/PremiumMessage.js